const supplierLayout = {
  quotation: '詢價單',
  pendingQuotation: '待報價',
  resolveQuotation: '已報價',
  other: '其他',
  purchaseOrder: '訂單',

  login: '登入',
  loginTitle: '登入WMS',
  acntNotExist: ' 帳號不存在,請檢查',
  acntNotAvailable: ' 帳號已存在或被禁用',
  loginFail: '登入失敗',
  updatePwd: '修改密碼',
  pwd: '密碼',
  inputPwd: '請輸入密碼',
  inputAct: '請輸入帳戶',
  inputPwdSec: '請再次輸入密碼',
  confirmPwd: '確認密碼',
  logOut: '登出',
  logOutTipTitle: '確定登出嗎？',
  logOutTipContent: '確定退出後將返回登入頁面。',
  confirmTip: "確定要拒絕此次問詢報價嗎？",
  confirmTip2: "報價後，採購商將收到你的報價，並可以接受或拒絕你的報價",
  pwdError: "密碼修改失敗",
  editPwd: "修改密碼",
  searchByKeyword: "輸入關鍵字蒐索",
  accountErr: "帳戶或密碼錯誤",
  deliveryNotice: '送貨通知',
  business: '商務',
  reconciliation: '對賬',
  contract: '契约管理',
  quotations: '報價',
  proQuotations: '商品報價',
  myQuotations: '我的報價',
};

export default supplierLayout;